export const audienceAdsStyles = () => ({
  '& .crud-audience-ad': Object.assign(
    {},
    {
      marginLeft: 32,

      '& .control-label': {
        margin: 0,
      },
      '& .form-control-static': {
        paddingTop: 7,
        paddingBottom: 7,
      },

      '& .alert': {
        marginLeft: 0,
      },

      '& .mobile-url': {
        marginTop: 32,
      },

      '& .ad-edit-action-buttons': {
        marginTop: 20,

        '& .save-ad-button': {
          marginRight: 12,
        },
      },

      '& .HelpTopic': {
        verticalAlign: 'middle',
      },

      '& .audience-ads-policy-container': {
        '& .alert-info-inline': {
          '& >a': {
            verticalAlign: 'middle',
          },
        },
      },

      '& .expand-url-options': {
        '& .spritedimagealign': {
          display: 'inline-block',
        },

        '& > span': {
          verticalAlign: 'unset',
        },
      },
    }
  ),

  '& .error-no-created-ad': {
    marginLeft: 32,
  },
});
